import React from 'react';

// CORE COMPONENTS
import Sprite from 'core/tools/Sprite';

// LOCAL PARTS
import RebillEpostSidebar from './RebillEpostSidebar';

// MAIN COMPONENT
const EpostButton = ({
  value,
  row: { original: { sales_id } = {} } = {}
}) => !value ? (
  <Sprite
    use="success"
    fill="light"
  />
) : (
  <RebillEpostSidebar.Button
    variant="warning"
    icon="email"
    payload={sales_id}
    link
  />
)


export default EpostButton